import {ConfigObjectType} from '@wallaby-ui/core';
import * as React from 'react';

import PatientListLayout from './PatientListLayout';

interface OwnProps {
  config: ConfigObjectType;
  route: string;
  componentParams?: any;
}

type Props = OwnProps;

export const PatientListLayoutContainer: React.FC<Props> = (props) => {
  const {config, ...restProps} = props;
  return <PatientListLayout {...restProps} config={config} />;
};
